import { AssetRequestCreateInput } from '@atom/types/assetRequest';
import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

// Returns true while the ARDOT 118 create form is incomplete: both approvers
// are required, a transfer needs a destination, and a request with no
// attribute changes must at least be a transfer.
export const getARDOTCreateDisabled = (
  createInputs: AssetRequestCreateInput,
  transferToggle: boolean,
): boolean => {
  const { reviewer, receiver, toCategoryId, attributes } = createInputs;

  const attributeChangeCount = !isNilOrEmpty(attributes)
    ? attributes.reduce((count, attribute) => {
        return attribute.newValue !== attribute.oldValue ? count + 1 : count;
      }, 0)
    : 0;

  return (
    isNilOrEmpty(reviewer) ||
    isNilOrEmpty(receiver) ||
    (transferToggle && isNilOrEmpty(toCategoryId)) ||
    (attributeChangeCount === 0 && isNilOrEmpty(toCategoryId))
  );
};
